import pluralize from 'pluralize';

const formatContentTypeLabel = label => {
    if (label === 'siteContent') return 'Pages';
    return pluralize(
        label
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/^./, char => char.toUpperCase())
    );
};

export const formatFilterLabel = (attribute, label) =>
    attribute === 'content_type' ? formatContentTypeLabel(label) : label;

export default formatContentTypeLabel;
